"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureExpFlagsWithPaginationParametersTypeSchema = exports.FeatureExpFlagsWithPaginationSearchTypeSchema = exports.FeatureExpFlagsWithPaginationTypeSchema = exports.FeatureExpFlagTypeSchema = exports.PatchFeatureExpFlagFlagshipAPIPayloadTypeSchema = exports.PostFeatureExpFlagFlagshipAPIPayloadTypeSchema = exports.FlagUsageTypeSchema = exports.FlagUsageStatusTypeSchema = exports.FeatureExpFlagUsageEnvironmentSchema = exports.FeatureExpFlagCampaignSchema = exports.FlagTypesSchema = exports.FeatureExpPostFlagTypeSchema = exports.PostFlagTypesSchema = exports.AllowedFlagTypeSchema = exports.AllowedFlagTypeEnumSchema = exports.AllowedQuickFiltersSchema = exports.AllowedQuickFilterEnumSchema = exports.FeatureExpFlagSortablePropTypeSchema = exports.FeatureExpFlagSortablePropEnumSchema = exports.FlagsCategoriesSchema = exports.CategoriesTypeSchema = exports.FlagUsageInCampaignSchema = exports.FeatureExpFlagCampaignTypeEnumSchema = exports.FeatureExpFlagSortablePropEnum = exports.FeatureExpFlagsWithPaginationOrderTypeSchema = exports.FeatureExpFlagsWithPaginationFiltersTypeSchema = exports.EnvironmentIdSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
const schemas_2 = require("../../../helpers/schemas");
exports.EnvironmentIdSchema = zod_1.z.string();
exports.FeatureExpFlagsWithPaginationFiltersTypeSchema = zod_1.z.object({
    used: zod_1.z.number().optional(),
    environmentIds: zod_1.z.tuple([exports.EnvironmentIdSchema]).optional(),
});
exports.FeatureExpFlagsWithPaginationOrderTypeSchema = zod_1.z.object({
    name: schemas_1.OrderBySchema.optional(),
    createdAt: schemas_1.OrderBySchema.optional(),
});
var FeatureExpFlagSortablePropEnum;
(function (FeatureExpFlagSortablePropEnum) {
    FeatureExpFlagSortablePropEnum["Name"] = "name";
    FeatureExpFlagSortablePropEnum["CreatedAt"] = "formatted_created_at";
})(FeatureExpFlagSortablePropEnum = exports.FeatureExpFlagSortablePropEnum || (exports.FeatureExpFlagSortablePropEnum = {}));
exports.FeatureExpFlagCampaignTypeEnumSchema = zod_1.z.enum(['ab', 'toggle', 'deployment', 'perso']);
exports.FlagUsageInCampaignSchema = zod_1.z.enum([
    'active',
    'draft',
    'paused',
    'interrupted',
    'hold',
    'deleted',
    'archived',
]);
exports.CategoriesTypeSchema = zod_1.z.string();
exports.FlagsCategoriesSchema = zod_1.z.array(exports.CategoriesTypeSchema);
exports.FeatureExpFlagSortablePropEnumSchema = zod_1.z.nativeEnum(FeatureExpFlagSortablePropEnum);
exports.FeatureExpFlagSortablePropTypeSchema = zod_1.z.union([
    zod_1.z.literal(FeatureExpFlagSortablePropEnum.Name),
    zod_1.z.literal(FeatureExpFlagSortablePropEnum.CreatedAt),
]);
exports.AllowedQuickFilterEnumSchema = zod_1.z.enum(['all', 'used', 'unused']);
exports.AllowedQuickFiltersSchema = exports.AllowedQuickFilterEnumSchema;
exports.AllowedFlagTypeEnumSchema = zod_1.z.enum(['string', 'number', 'object', 'boolean', 'array']);
exports.AllowedFlagTypeSchema = exports.AllowedFlagTypeEnumSchema;
exports.PostFlagTypesSchema = zod_1.z.union([
    zod_1.z.object({
        type: zod_1.z.literal('string'),
        default_value: zod_1.z.string(),
        predefined_values: zod_1.z.array(zod_1.z.string()),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('number'),
        default_value: zod_1.z.number(),
        predefined_values: zod_1.z.array(zod_1.z.number()),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('object'),
        default_value: zod_1.z.string(),
        predefined_values: zod_1.z.tuple([]),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('boolean'),
        default_value: zod_1.z.string(),
        predefined_values: zod_1.z.tuple([]),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('array'),
        default_value: zod_1.z.string(),
        predefined_values: zod_1.z.tuple([]),
    }),
]);
exports.FeatureExpPostFlagTypeSchema = exports.PostFlagTypesSchema.and(zod_1.z.object({
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    categories: zod_1.z.array(exports.CategoriesTypeSchema),
}));
exports.FlagTypesSchema = zod_1.z.union([
    zod_1.z.object({
        type: zod_1.z.literal('string'),
        default_value: zod_1.z.string(),
        predefined_values: zod_1.z.array(zod_1.z.string()),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('number'),
        default_value: zod_1.z
            .union([zod_1.z.number(), zod_1.z.string()])
            .refine((val) => !Number.isNaN(Number(val)), // Ensure that the string can be converted to a number
        { message: 'Expected a number or a numeric string for default_value' })
            .transform((val) => (typeof val === 'string' ? Number(val) : val)),
        predefined_values: zod_1.z.array(zod_1.z.number()),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('boolean'),
        default_value: zod_1.z.string(),
        predefined_values: zod_1.z.tuple([]), // No predefined values for boolean
    }),
    zod_1.z.object({
        type: zod_1.z.literal('object'),
        default_value: zod_1.z.string(),
        predefined_values: zod_1.z.tuple([]),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('array'),
        default_value: zod_1.z.string(),
        predefined_values: zod_1.z.tuple([]),
    }),
]);
exports.FeatureExpFlagCampaignSchema = zod_1.z.object({
    archivedAt: schemas_2.ApiDateTimeSchema,
    createdAt: schemas_2.ApiDateTimeSchema,
    description: zod_1.z.string(),
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    status: exports.FlagUsageInCampaignSchema,
    type: exports.FeatureExpFlagCampaignTypeEnumSchema,
    project: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
    }),
    variationGroup: zod_1.z.any(),
});
exports.FeatureExpFlagUsageEnvironmentSchema = zod_1.z.record(zod_1.z.any()).and(zod_1.z.object({
    env_name: zod_1.z.string(),
    is_main: zod_1.z.boolean(),
}));
exports.FlagUsageStatusTypeSchema = zod_1.z.union([
    zod_1.z.array(exports.FeatureExpFlagUsageEnvironmentSchema),
    zod_1.z.record(exports.FeatureExpFlagUsageEnvironmentSchema),
]);
exports.FlagUsageTypeSchema = zod_1.z.object({
    active: exports.FlagUsageStatusTypeSchema,
    paused: exports.FlagUsageStatusTypeSchema,
    draft: exports.FlagUsageStatusTypeSchema,
    hold: exports.FlagUsageStatusTypeSchema,
    archived: exports.FlagUsageStatusTypeSchema,
    codeReferences: zod_1.z.record(zod_1.z.number()),
});
exports.PostFeatureExpFlagFlagshipAPIPayloadTypeSchema = exports.FeatureExpPostFlagTypeSchema.and(zod_1.z.object({
    accountId: zod_1.z.string(),
}));
exports.PatchFeatureExpFlagFlagshipAPIPayloadTypeSchema = exports.FeatureExpPostFlagTypeSchema.and(zod_1.z.object({
    accountId: zod_1.z.string(),
    flagId: zod_1.z.string(),
}));
exports.FeatureExpFlagTypeSchema = exports.FlagTypesSchema.and(zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    source: zod_1.z.union([zod_1.z.literal('manual'), zod_1.z.literal('cli')]),
    categories: zod_1.z.array(exports.CategoriesTypeSchema),
    formatted_created_at: schemas_2.ApiDateTimeSchema,
    created_by: zod_1.z.string().nullable(),
    formatted_updated_at: schemas_2.ApiDateTimeSchema.nullable(),
    updated_by: zod_1.z.string().nullable(),
    usage: exports.FlagUsageTypeSchema,
}));
exports.FeatureExpFlagsWithPaginationTypeSchema = schemas_1.FeatureExpPaginationSchema.and(zod_1.z.object({
    items: zod_1.z.array(exports.FeatureExpFlagTypeSchema),
}));
exports.FeatureExpFlagsWithPaginationSearchTypeSchema = zod_1.z.object({
    type: zod_1.z.array(exports.AllowedFlagTypeSchema).optional(),
    usage: zod_1.z.array(exports.FlagUsageInCampaignSchema).optional(),
    from: zod_1.z.string().optional(),
    to: zod_1.z.string().optional(),
    category: zod_1.z.array(exports.CategoriesTypeSchema).optional(),
    name_description: zod_1.z.string().optional(),
    id: zod_1.z.string().optional(),
});
exports.FeatureExpFlagsWithPaginationParametersTypeSchema = schemas_1.FeatureExpPaginationQueryParamSchema.and(zod_1.z.object({
    filters: exports.FeatureExpFlagsWithPaginationFiltersTypeSchema.optional(),
    _order: exports.FeatureExpFlagsWithPaginationOrderTypeSchema.optional(),
    search: exports.FeatureExpFlagsWithPaginationSearchTypeSchema.optional(),
    _max_per_page: zod_1.z.number().optional(),
}));
//# sourceMappingURL=schemas.js.map